// 贷款合同、抵押合同、其他
export enum templateTypeName {
  loan = '贷款合同',
  mortgage = '抵押合同',
  guarantee = '担保合同',
  compensatory = '代偿合同',
  debt = '债转合同',
  data = '数据授权',
  other = '其他',
  prove = '结清证明',
  promissoryNote = '借款借据',
  intermediary = '居间合同',
  cpsIntermediary = 'CPS居间合同'
}

export enum templateTypeValue {
  loan = 1,
  mortgage,
  guarantee,
  compensatory,
  debt,
  data,
  other,
  prove,
  promissoryNote,
  intermediary,
  cpsIntermediary = 12
}

export const contractTypeList = [
  { label: templateTypeName.loan, value: templateTypeValue.loan },
  { label: templateTypeName.mortgage, value: templateTypeValue.mortgage },
  { label: templateTypeName.guarantee, value: templateTypeValue.guarantee },
  {
    label: templateTypeName.compensatory,
    value: templateTypeValue.compensatory
  },
  { label: templateTypeName.debt, value: templateTypeValue.debt },
  { label: templateTypeName.data, value: templateTypeValue.data },
  { label: templateTypeName.other, value: templateTypeValue.other },
  { label: templateTypeName.prove, value: templateTypeValue.prove },
  { label: templateTypeName.promissoryNote, value: templateTypeValue.promissoryNote },
  { label: templateTypeName.intermediary, value: templateTypeValue.intermediary },
  { label: templateTypeName.cpsIntermediary, value: templateTypeValue.cpsIntermediary }
]

// 关联应用
export const associationAppList = [
  { label: '合作机构管理', value: 1 },
  { label: '担保方管理', value: 2 },
  { label: '产品管理', value: 3 },
  { label: '进件订单管理', value: 4 },
  { label: '放款管理', value: 5 },
  { label: '办抵工单', value: 6 },
  { label: '账单管理', value: 7 },
  { label: '应收款管理', value: 8 },
  { label: '资管明细', value: 9 },
  { label: 'cps签单管理', value: 10 }
]

export enum SignRadioLabel {
  single = '单方签署',
  both = '双方签署',
  more = '多方签署'
}

export enum SignRadioValue {
  single = 1,
  both = 2,
  more = 3
}

export enum SignMainLabel {
  company = '企业',
  person = '个人'
}

export enum SignMainValue {
  company = 1,
  person = 2
}

export const signMainList = [
  { value: SignMainValue.company, label: SignMainLabel.company },
  { value: SignMainValue.person, label: SignMainLabel.person }
]

export enum SignMethodLabel {
  sign = '签署',
  legalPerson = '法人签署'
}

export enum SignMethodValue {
  sign = 'sign',
  legalPerson = 'legalPerson'
}

export const signMethodList = [
  { value: SignMethodValue.sign, label: SignMethodLabel.sign },
  { value: SignMethodValue.legalPerson, label: SignMethodLabel.legalPerson }
]

export interface SignListItem {
  name: string
  mainType: number
  method: string[]
  info: string
}

export interface FormState {
  templateName: string | undefined
  file: Recordable[]
  duration: string | undefined
  signType: number | undefined
  signList: SignListItem[]
  contractType: string | undefined
  scriptTemplateId: string | undefined
  scriptTemplateCode: string | undefined
}

export enum DocTemplateType {
  PDF,
  HTML
}

export enum ClearRuleNames {
  no = '不清零',
  day = '每日清零',
  month = '每月清零',
  year = '每年清零'
}

export enum ClearRuleValues {
  no,
  day,
  month,
  year
}

export enum ValueTypeNames {
  correlation = '关联表单字段',
  defaultValue = '默认值'
}

export enum ValueTypeValues {
  correlation = 1,
  defaultValue = 2
}

export const valueTypeList = [
  { value: ValueTypeValues.correlation, label: ValueTypeNames.correlation },
  { value: ValueTypeValues.defaultValue, label: ValueTypeNames.defaultValue }
]

export enum ResultStatus {
  success = 'success',
  pending = 'pending',
  fail = 'fail'
}

export enum SealTypeNames {
  legal = '法人章',
  company = '企业公章'
}

export enum SealTypeValues {
  legal = 1,
  company = 2
}

export const sealTypeList = [
  { label: SealTypeNames.legal, value: SealTypeValues.legal },
  { label: SealTypeNames.company, value: SealTypeValues.company }
]

export const autoSignList = [
  { label: '是', value: 1 },
  { label: '否', value: 0 }
]

export const fieldSignTypeList = [
  { label: '主表', value: 0 },
  { label: 'Q1-子表第一行', value: 1 },
  { label: 'Q1-子表第二行', value: 2 },
  { label: 'Q1-子表第三行', value: 3 },
  { label: 'Q1-子表第四行', value: 4 },
  { label: 'Q1-子表第五行', value: 5 },
  { label: 'Q1-子表第六行', value: 6 },
  { label: 'Q1-子表第七行', value: 7 },
  { label: 'Q1-子表第八行', value: 8 },
  { label: 'Q1-子表第九行', value: 9 },
  { label: 'Q1-子表第十行', value: 10 }
]

export interface FieldMappingItem {
  fieldRelateType: string // 字段值关联类型 1关联表单字段 2默认值
  fieldValue: string // 	字段值配置
  id: string // 行id
  mappingComponentId: string // 	控件ID（易签宝）
  mappingComponentName: string // 控件名称（易签宝）
  mappingComponentType: string // 控件类型（易签宝）1-单行文本 2-数字 18-动态表格
}

export interface MainMappingItem {
  fieldKey: string // 字段key
  fieldName: string // 字段名称
  fieldRelateType: number // 字段值关联类型
  fieldValue: string // 字段值配置
  id: number // 行id
  signSubjectId: number // 签署方id
  fieldSignType: number // 字段类型
}

export interface SignMappingItem {
  id: string // 行id
  mappingComponentId: string // 控件ID（易签宝）
  sealType: string // 印章类型(枚举) 1 法人章 2 企业公章
  signSubjectId: string // 签署方id
  autoSign: string
}
